import { styled, Switch } from '@mui/material';
import { COLOR_MAP } from '../../../constants/ColorNames';

const SwitchWrapper = styled(Switch)(({ theme }) => ({
    width: 32,
    height: 16,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        color: COLOR_MAP.DARK_PURPLE,
        transform: 'translateX(16px)',
        '& .MuiSwitch-thumb:before': {
          content: "''",
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="8" width="8" viewBox="0 0 8 8"><path fill="purple" d="M7.31821 1.31428C7.53121 1.49001 7.56143 1.80515 7.3857 2.01816L3.80066 6.36366C3.32069 6.94544 2.42934 6.94545 1.94937 6.36366L0.614327 4.74543C0.438595 4.53242 0.468814 4.21728 0.681822 4.04155C0.894831 3.86582 1.20997 3.89604 1.3857 4.10905L2.72074 5.72728C2.80074 5.82424 2.94929 5.82424 3.02929 5.72728L6.61433 1.38177C6.79006 1.16876 7.1052 1.13855 7.31821 1.31428Z"/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: COLOR_MAP.BLACK,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: 'white',
      width: 12,
      height: 12,
      borderRadius: 6,
      '&::before': {
        backgroundImage: 'none',
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: COLOR_MAP.BORDER_GREY,
      boxSizing: 'border-box'
    },
  }));


export default SwitchWrapper